/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_Payment_ReferenceInputs */

const vi_report_debt_payment_reference = /** @type {(inputs: Report_Debt_Payment_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã tham chiếu`)
};

/**

* @param {Report_Debt_Payment_ReferenceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_payment_reference = /** @type {((inputs?: Report_Debt_Payment_ReferenceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_Payment_ReferenceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_payment_reference(inputs)
});